module.exports = __webpack_public_path__ + "img/voiding-chart-slide5.ff59d833.gif";